import { ArrowDownIcon, ArrowDownUpIcon, ArrowUpIcon } from "lucide-react";
import { Button } from "../ui/button";

type props = {
	label: string;
	sortDir: "asc" | "desc" | "none";
	setSortDir: (dir: "asc" | "desc" | "none") => void;
};

const TableHeadSortButton = ({ label, sortDir, setSortDir }: props) => {
	const toggleSortDir = () => {
		if (sortDir === "asc") {
			setSortDir("desc");
		} else if (sortDir === "desc") {
			setSortDir("none");
		} else {
			setSortDir("asc");
		}
	};
	return (
		<Button
			variant="ghost"
			onClick={toggleSortDir}
			className="group [&_svg]:size-3"
		>
			{label}
			{sortDir === "asc" && <ArrowUpIcon />}
			{sortDir === "desc" && <ArrowDownIcon />}
			{sortDir === "none" && <ArrowDownUpIcon />}
		</Button>
	);
};

export default TableHeadSortButton;
